import React, { useEffect, useState } from 'react';
import OneProduct from '../../Store/oneProduct';
import { db } from '../../../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box, Grid } from '@mui/material';
import EmptyPage from '../../Commons/EmptyPage';

const AddedProduct = () => {
  const [products, setProducts] = useState([]);
  const { userId } = useParams();

  useEffect(() => {
    const fetchProducts = async () => {
      const storeRef = doc(db, 'profileProduct', userId);
      const data = await getDoc(storeRef);
      if (data.exists()) {
        const productsData = data.data().product || [];
        setProducts(productsData);
      }
    };
    fetchProducts();
  }, [userId]);

  if (products.length === 0) {
    return <EmptyPage message="No products added yet." />;
  }

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Added Products
      </Typography>
      <Typography variant="body1" align="center" color="text.secondary" sx={{ mb: 3 }}>
        You have {products.length} {products.length === 1 ? 'product' : 'products'} added.
      </Typography>
      <Grid container spacing={4}>
        {products.map((product) => (
          <Grid item xs={12} sm={6} md={4} key={product._id}>
            <OneProduct product={product} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default AddedProduct;
